//import { Router } from 'router5'
import createRouter from 'router5'
import browserPlugin from 'router5-plugin-browser'

import LogMiddlewareFactory from '@kaidam/fc-shared/src/frontend/router/middleware/log'
import AuthorizeMiddlewareFactory from '@kaidam/fc-shared/src/frontend/router/middleware/authorize'
import RedirectMiddlewareFactory from '@kaidam/fc-shared/src/frontend/router/middleware/redirect'
import TriggerMiddlewareFactory from '@kaidam/fc-shared/src/frontend/router/middleware/trigger'

import {
  AppRoute,
} from '../types/router'

import {
  RootState,
} from '../types/store'

const authorizeMiddleware = AuthorizeMiddlewareFactory<RootState>()
const logMiddleware = LogMiddlewareFactory<RootState>()
const redirectMiddleware = RedirectMiddlewareFactory<RootState>()
const triggerMiddleware = TriggerMiddlewareFactory<RootState>()

const Router = (routes: AppRoute<RootState>[]) => {
  const router = createRouter(routes, {
    defaultRoute: 'notfound',
    queryParamsMode: 'loose',
  })

  router.usePlugin(browserPlugin({}))
  router.useMiddleware(authorizeMiddleware(routes))
  router.useMiddleware(logMiddleware(routes))
  router.useMiddleware(redirectMiddleware(routes))
  router.useMiddleware(triggerMiddleware(routes))

  return router
}

export default Router
